import React, {useState, useEffect} from 'react'
// Styles
import './mbsktco.style.css'
// Actions
import {Base_API} from '../../_actions/matcher'

function MyBasket_TabConfirmOrder({ quantitySelected, totalPrice, calCartData, refCampaign, type }) {

    const [discountText, setDiscountText] = useState('');

    useEffect(() => {
        dataInit();
        // console.log('Cal Cart Data: ',calCartData);
    })

    const dataInit = () => {
        discountTextInit(); 
    }

    const discountTextInit = () => {
        if(calCartData.isPromotion !== 0)
        {
            setDiscountText('ส่วนลด '+calCartData.PromotionText);
        }
    }

    const handleSubmit = () => {
        if(type === 'packages')
        {
            window.location.href = `${Base_API.pathWeb}/n-health/confirm-order/${refCampaign}`;
        }else
        {
            window.location.href = `${Base_API.pathWeb}/n-health/confirm-order-nhservices/${refCampaign}`;
        }
    }

    return (
        <div className="mbsktco-container">
            {/* top */}
            <div className="top">
                {/* header wrap */}
                <div className="header-wrap">
                    <p className="qtt t-normal">
                        {calCartData.totalAmount} รายการ
                    </p>
                    <p className="ttp t-normal">
                        ฿ {Number(calCartData.totalPrice).toLocaleString('th', {minimumFractionDigits: 2})}
                    </p>
                </div>
                {/* free gift */}
                <p className="free-gift t-normal t-red">
                    <span>{discountText}</span>
                    <span>- ฿{Number(calCartData.discountPrice).toLocaleString('th', {minimumFractionDigits: 2})}</span>
                </p>
            </div>
            {/* bottom */}
            <div className="bottom">
                <div className="ttp">
                    <p className="ttp-text t-bold ts-normal">รวมทั้งหมด</p>
                    <p className="ttp t-bold ts-normal">
                        ฿ {Number(calCartData.netPrice).toLocaleString('th', {minimumFractionDigits: 2})}
                    </p>
                </div>
                {/* btn submit */}
                <button 
                    type="button" 
                    className="bsk-submit"
                    disabled={calCartData.totalAmount <= 0 ? true : false}
                    onClick={handleSubmit}
                >
                    ยืนยันการสั่งซื้อ
                </button>
            </div>
        </div>
    )
}

export default MyBasket_TabConfirmOrder